import React from "react";
import { Check, X } from "lucide-react";

export default function Comparison({ rows = [] }) {
  return (
    <section className="py-16 md:py-24" style={{ background: "var(--ev-bg-2)" }}>
      <div className="mx-auto max-w-[1200px] px-5 md:px-10">
        <div className="max-w-2xl">
          <div className="eyebrow">Why it works</div>
          <h2 className="font-serif-ev mt-4 text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight">
            Evolonef <span className="italic" style={{ color: "var(--ev-blue-2)" }}>vs.</span> generic self-help.
          </h2>
        </div>

        <div className="mt-10 ev-card overflow-hidden">
          <div className="grid grid-cols-3 border-b hairline text-sm">
            <div className="p-4 md:p-6"></div>
            <div className="p-4 md:p-6 text-center font-serif-ev text-lg md:text-xl" style={{ color: "var(--ev-blue-2)" }}>Evolonef</div>
            <div className="p-4 md:p-6 text-center font-serif-ev text-lg md:text-xl" style={{ color: "var(--ev-muted)" }}>Others</div>
          </div>
          {rows.map((r, i) => (
            <div key={r.label} className={`grid grid-cols-3 text-sm md:text-base ${i !== rows.length - 1 ? "border-b hairline" : ""}`}>
              <div className="p-4 md:p-6 font-medium" style={{ color: "var(--ev-ink)" }}>{r.label}</div>
              <div className="p-4 md:p-6 flex items-start gap-2" style={{ background: "rgba(141,169,196,0.06)" }}>
                <Check className="w-4 h-4 mt-1 flex-shrink-0" style={{ color: "var(--ev-blue-2)" }} />
                <span>{r.us}</span>
              </div>
              <div className="p-4 md:p-6 flex items-start gap-2" style={{ color: "var(--ev-muted)" }}>
                <X className="w-4 h-4 mt-1 flex-shrink-0 opacity-70" />
                <span>{r.them}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
